import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=18b00cbe&scoped=true"
import script from "./ShareModal.vue?vue&type=script&lang=js"
export * from "./ShareModal.vue?vue&type=script&lang=js"
import style0 from "./ShareModal.vue?vue&type=style&index=0&id=18b00cbe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b00cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b00cbe')) {
      api.createRecord('18b00cbe', component.options)
    } else {
      api.reload('18b00cbe', component.options)
    }
    module.hot.accept("./ShareModal.vue?vue&type=template&id=18b00cbe&scoped=true", function () {
      api.rerender('18b00cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/ShareModal.vue"
export default component.exports